import { Box, FormControl, FormControlLabel, Grid, Radio, RadioGroup, Typography } from '@mui/material';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const TipoTarea = () => {
    const { promptData, setPromptData } = useActividadesContext();

    const handleTipoTareaChange = (event) => {
        const selectedTipoTarea = event.target.value;

        setPromptData((prevData) => ({
            ...prevData,
            tipo_actividad: selectedTipoTarea
        }));
    };

    return (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mb={3}>
            <Box>
                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                    <Typography sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold',  color: '#336B87' }}>
                        Tipo de actividad *
                    </Typography>
                </Box>
                <FormControl component="fieldset">
                    <RadioGroup
                        aria-label="niveles de desempeño"
                        name="nivel_desempeno"
                        value={promptData.tipo_actividad}
                        onChange={handleTipoTareaChange}
                    >
                        <FormControlLabel
                            value="Texto"
                            control={<Radio sx={{ color: '#336B87' }} />}
                            label={
                                <Typography sx={{ fontFamily: 'montserrat', fontSize: '0.8rem', color: '#336B87', 
                                    '&.Mui-checked': {
                                            color: '#336B87', 
                                        }, }}>
                                    Texto
                                </Typography>
                            }
                        />
                        <FormControlLabel
                            value="Actividad"
                            control={<Radio sx={{ color: '#336B87' }} />}
                            label={
                                <Typography sx={{ fontFamily: 'montserrat', fontSize: '0.8rem', color: '#336B87', 
                                    '&.Mui-checked': {
                                            color: '#336B87', 
                                        }, }}>
                                    Actividad
                                </Typography>
                            }
                        />
                       
                    </RadioGroup>
                </FormControl>
            </Box>
        </Grid>
    );
};

export default TipoTarea;
